module.exports = __webpack_public_path__ + "static/media/no-img-news.0774aacb.webp";